import React from 'react';
import BaseComponent from 'components/BaseComponent';
import Icon from 'components/Icon';
import { 
    FiletypeComb,
    getDefaultFileName,
    canNotMax,
    canAnchor,
} from 'components/Playlist';
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";


export default class PlaylistContextMenu extends BaseComponent {
    constructor() {
        super();
    }

    

    render() {
        const { id, areaType, anchor_type, lock, onUp, onDown, onTop, onBottom, onMax, onDelete, onAnchor, onLock } = this.props;
        return (
            <ContextMenu id={id}>
            {
              areaType === 9 ? null : (
                <React.Fragment>
                  <MenuItem data={{foo: 'bar'}} onClick={(event) => {
                    onUp && onUp(event, 'workArea')
                  }}>
                    <Icon className="up-circle-o"/>  {window.language['playlist.up']}
                  </MenuItem>
                  <MenuItem data={{foo: 'bar'}} onClick={(event) => {
                    onDown && onDown(event, 'workArea')
                  }}>
                    <Icon className="down-circle-o"/>  {window.language['playlist.down']}
                  </MenuItem>
                  <MenuItem data={{foo: 'bar'}} onClick={(event) => {
                    onTop && onTop(event, 'workArea')
                  }}>
                    <Icon className="top"/>  {window.language['playlist.top']}
                  </MenuItem>
                  <MenuItem data={{foo: 'bar'}} onClick={(event) => {
                    onBottom && onBottom(event, 'workArea')
                  }}>
                    <Icon className="bottom"/>  {window.language['playlist.bottom']}
                  </MenuItem>
                  <MenuItem divider />
                  {
                    canNotMax[areaType] ? null : 
                    <MenuItem data={{foo: 'bar'}} onClick={(event) => {
                      onMax && onMax(event, 'workArea')
                    }}>
                      <Icon className="maxmize-o"/>  {window.language['playlist.max']}
                    </MenuItem>
                  }
                </React.Fragment>
              )
            }
            <MenuItem data={{foo: 'bar'}} onClick={(event) => {
              onDelete && onDelete(event, 'workArea')
            }}>
              <Icon className="delete-o"/>  {window.language['playlist.delete']}
            </MenuItem>
            <MenuItem divider />
            {
              // 视频， 直播源，互动，网页，图片，背景
              canAnchor[areaType] ? (
                <React.Fragment>
                  <MenuItem data={{foo: 'bar'}} onClick={(event) => {
                    onAnchor && onAnchor(event, 'workArea')
                  }}>
                    {anchor_type === 1 ? <Icon className="anchor"/> : <Icon className="anchor-o"/>}  {anchor_type === 1 ? window.language['playlist.cancelMainPlayArea'] : window.language['playlist.setMainPlayArea']}
                  </MenuItem>
                </React.Fragment>
              ) : null
            }
            <MenuItem data={{foo: 'bar'}} onClick={(event) => {
                onLock && onLock(event, 'workArea')
            }}>
            {lock ? <Icon className="unlock-o"/> : <Icon className="lock-o"/>}  {lock ? window.language['playlist.unlock'] : window.language['playlist.lock']}
            </MenuItem>
          </ContextMenu>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Playlist/PlaylistContextMenu.js